import React from 'react';
import { css, cx } from '@/styled-system/css';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

/**
 * Footprint of Spruce :)
 *
 * First Year: Oldest content on the site or year of first site publication
 * Last Year: Last time this website was modified. Dynamic because who wants to do this each year.
 *
 * When `pinecone.zillow-closing` feature flag is ON, Spruce Holdings info
 * is replaced with Zillow Closing, Inc. branding (no date range shown).
 */
export const Copyright: React.FC<{ className?: string }> = ({ className }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const companyName = isZillowClosingEnabled ? 'Zillow Closing, Inc.' : 'Spruce Holdings Inc.';

  return (
    <footer
      className={cx(
        css({
          margin: 0,
          padding: '16px',
          width: '100%',
          textAlign: 'center',
          backgroundColor: 'white',
          borderTop: '1px solid',
          borderColor: 'gray.200',
        }),
        className
      )}
    >
      {isZillowClosingEnabled ? `© ${companyName}` : `2017 - ${new Date().getFullYear()} © ${companyName}`}
    </footer>
  );
};
